module.exports = __webpack_public_path__ + "img/20230130065839543gw0.5bfb5247.jpg";